import shipmentRecordDirective from './shipment_record.directive';
import shipmentRouteFilter from './shipment_route.filter'

let shipmentRecordModule = angular.module('shipmentRecord', [
  ])
  .directive('shipmentRecord', shipmentRecordDirective)
  .filter('shipmentRouteFilter', shipmentRouteFilter)  

  .name;

export default shipmentRecordModule;


// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/shipment_record/index.js